export default "<p>modal works!</p>\n"